<app-dialog
  [visible]="visible"
  [width]="'520px'"
  [showHeader]="false"
  [closable]="true"
  appendTo="body"
  [overlayZIndex]="99999"
  (visibleChange)="visibleChange.emit($event)">
  <ng-container ngProjectAs="content">
    <div class="delete-modal">
      <img
        class="delete-modal__preview"
        [src]="previewUrl || 'assets/icons/main/light/upload-img-bg.svg'"
        alt="" />
      <div class="delete-modal__body">
        <h3>{{ "UPLOADED_GEO_IMAGES.DELETE_TITLE" | translate }}</h3>
        <p>{{ "UPLOADED_GEO_IMAGES.DELETE_DESCRIPTION" | translate }}</p>
        <div class="delete-modal__meta">
          <span>{{ item?.title }}</span>
        </div>
      </div>
    </div>
  </ng-container>
  <ng-container ngProjectAs="footer">
    <div class="delete-modal__footer">
      <app-secondary-button
        [width]="'140px'"
        [title]="'UPLOADED_GEO_IMAGES.MODAL_CANCEL' | translate"
        (action)="handleCancel()"></app-secondary-button>
      <!-- No catalog button carries a destructive style (DEV-RULES §4.1 lists only primary/secondary/save/
           clear/export/back); app-button variant="danger" is what the sibling field-photo-delete-modal
           uses for the same gap. -->
      <app-button
        variant="danger"
        [loading]="loading"
        (onClick)="handleConfirm()">
        {{ "UPLOADED_GEO_IMAGES.DELETE_CONFIRM" | translate }}
      </app-button>
    </div>
  </ng-container>
</app-dialog>
